import { Button } from '@common/components/Button';
import Portal from '@common/components/Portal';
import { StickyBarContent } from '@common/components/StickyBar';
import { useTranslations } from '@lang';
import { some } from '@utils/some';

import { ButtonWrapper } from '../../components/ExperienceDetails/ExperienceDetails.styles';
import { ExtrasSection } from '../ExtrasStep/ExtrasSection';
import { StyledDateRangeIndicator } from '../FormSteps.styles';
import { useHashNavigation } from '../hooks/useHashNavigation';
import { GuestDetailsWrapper, TitleWrapper } from './RoomExtrasStep.styles';
import { PageTitle } from '../FormSteps.styles';
import { usePackageConfiguration, useWizardNavigation, useCurrentStep } from '../../contexts';

export const RoomExtrasStep = () => {
  const { t } = useTranslations();

  const { journeyParams, rate, availableExtras = [] } = usePackageConfiguration();
  const { stickyBarId, handleNextStep } = useWizardNavigation();
  const { packageTotalPrice, hash } = useCurrentStep();

  useHashNavigation({ hash });
  const onSubmit = () => {
    handleNextStep();
  };

  return (
    <GuestDetailsWrapper>
      {some(availableExtras) && (
        <>
          <TitleWrapper>
            <PageTitle>{t('room.extrasStepTitle')}</PageTitle>
          </TitleWrapper>

          <ExtrasSection />
        </>
      )}
      <Portal selector={`#${stickyBarId}`}>
        <StickyBarContent
          name={rate.title || ''}
          subtitle={
            <StyledDateRangeIndicator
              fromDate={journeyParams.fromDate}
              toDate={journeyParams.toDate}
            />
          }
          displayedPrice={packageTotalPrice}
          button={
            <ButtonWrapper>
              <Button isPrimary onClick={onSubmit}>
                {t('spa.package.nextStep')}
              </Button>
            </ButtonWrapper>
          }
        />
      </Portal>
    </GuestDetailsWrapper>
  );
};
